import { useGetShow } from '@openapi/shows/shows';
import { getSlotTemplate } from '../helpers/slotTemplate';

/**
 * Loads a show's rental slot template. `isRentalShow` is true when the show has a
 * template or the legacy rentalMode flag is on.
 */
export function useSlotTemplate(showId) {
    const { data: show } = useGetShow(Number(showId), { query: { enabled: !!showId } });
    const template = getSlotTemplate(show);
    return {
        show,
        template,
        isRentalShow: template.length > 0 || !!show?.marketing?.rentalMode,
    };
}

export default useSlotTemplate;
